import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { ApiError, Data, Meta } from 'utils/types';

import c from '../utils/constants';

interface Result {
  data: Data[];
  meta: Meta;
}

export default function useGetFields(params: { [key: string]: any } = {}) {
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  return useQuery<Result, ApiError>({
    queryKey: [c.FIELDS, params],
    queryFn: async () => {
      const api = new Api(args);

      const data: Result = await api.get(
        await withAcl({
          account: {
            url: 'api/v1/data',
            params,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/data`,
            params,
          },
        }),
      );

      return data;
    },
  });
}
